// @flow
import React from 'react';
import styled, { withTheme } from 'styled-components';
import Radio from 'common/domain/radio';
import PrintingHeader from 'common/modules/printing/components/PrintingHeader';
import { CentralMarket } from '../../centralMarkets/domain/CentralMarket';

type Props = {
  title: string;
  radio: Radio;
  centralMarket: ?CentralMarket;

  theme: any;
}

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${({ theme }) => theme.metrics.margin}px 0;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  margin-bottom: ${({ theme }) => theme.metrics.margin}px;
`;

function MetricsPrintingHeader(props: Props) {
  const { theme, title, radio, centralMarket } = props;

  return (
    <React.Fragment>
      <PrintingHeader radio={radio} centralMarket={centralMarket} />
      <Header>
        <Title style={{ ...theme.fonts.style.secondary, fontWeight: 'bold' }}>{title}</Title>
      </Header>
    </React.Fragment>
  );
}

export default withTheme(MetricsPrintingHeader);



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/printing/MetricsPrintingHeader.js